import router from '@/router';
export function toPage(url, type, name) {
  // 参数校验
  if (!url && !name) {
    console.error('toPage: 必须提供url或name参数');
    return;
  }

  // 辅助函数：根据type执行路由跳转
  function navigate(routeObj) {
    console.log(routeObj);
    try {
      switch (type) {
        case 'replace':
          router.replace(routeObj);
          break;
        default:
          router.push(routeObj);
          break;
      }
    } catch (error) {
      console.error('toPage: 路由跳转失败', error);
    }
  }

  // 根据url和name执行跳转
  if (url) {
    if (url.indexOf('http') !== -1) {
      window.location.href = url;
    } else {
      navigate({ path: url });
    }
  } else if (name) {
    navigate({ name });
  }
}
